export const navItems = [
  'Destinations',
  'Space Trains',
  'Pricing',
  'Private Dining',
];

export const col1 = ['About Us', ' Destinations', 'Spacecraft'];
export const col2 = ['Terms of Service', 'Privacy Policy', 'Refund Policy'];
export const col3 = ['News', 'Rail'];
export const social = [
  '/img/facebook.svg',
  '/img/instagram.svg',
  '/img/twitter.svg',
  '/img/linkedin.svg',
];

export const sections = [
  {
    image: '/img/unsplash2.jpg',
    title: 'Featured Destinations',
    body: 'Experience the Red Planet like never before. Join our Mars Expedition for an unforgettable journey.',
    variant: 'primary',
    buttonText: 'Learn More',
  },
  {
    image: '/img/unsplash3.jpg',
    title: 'Explore the Universe',
    body: 'Embark on a journey to the cosmos and discover the wonders of space travel. Our space adventures offer once-in-a-lifetime experiences that will leave you in awe of the universe.',
    variant: 'primary',
    buttonText: 'View Destinations',
    flip: true,
  },
];

export const cards = [
  {
    image: '/img/card1.webp',
    title: 'Mars Expedition',
    body: 'Experience the Red Planet like never before. Join our Mars Expedition for an unforgettable journey',
    buttonText: 'Learn More',
    variant: 'apricot',
  },
  {
    image: '/img/card2.webp',
    title: 'Interstellar Adventure',
    body: 'Embark on a journey to the outer reaches of the galaxy with our Interstellar Adventure package. Witness stunning nebulae, explore alien worlds, and experience zero-gravity like never before.',
    buttonText: 'Explore',
    variant: 'apricot',
  },
  {
    image: '/img/card3.webp',
    title: 'Deep Space Odyssey',
    body: 'Embark on a journey to the far reaches of the universe with our Deep Space Odyssey. Witness distant galaxies, explore nebulae, and experience the wonders of deep space.',
    buttonText: 'Read More',
    variant: 'apricot',
  },
];
export const cards2 = [
  {
    image: '/img/card1.webp',
    title: 'Mars Expedition',
    body: 'Experience the Red Planet like never before. Join our Mars Expedition for an unforgettable journey',
    buttonText: 'Black',
    variant: 'black',
  },
  {
    image: '/img/card2.webp',
    title: 'Interstellar Adventure',
    body: 'Embark on a journey to the outer reaches of the galaxy with our Interstellar Adventure package. Witness stunning nebulae, explore alien worlds, and experience zero-gravity like never before.',
    buttonText: 'Outline Primary',
    variant: 'outlinePrimary',
  },
  {
    image: '/img/card3.webp',
    title: 'Deep Space Odyssey',
    body: 'Embark on a journey to the far reaches of the universe with our Deep Space Odyssey. Witness distant galaxies, explore nebulae, and experience the wonders of deep space.',
    buttonText: 'Outline White',
    variant: 'outlineWhite',
  },
];
